export default __webpack_public_path__ + "static/media/settings.505e9fcf.svg";